<br />
<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<h6 class="prd-h6"> Board Members </h6>

<div class="card" >
    <div class="card-body" *ngIf = 'displayState.workingDiv'>    
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
            </div>
        </div>
    </div>
</div>
<br />

<div class="row" *ngIf='!this.displayState.MemberDiv' >
  <div class="col-md-2 offset-1">
      <button class="btn btn-sm btn-link" (click)="newBoardMember()" [disabled]="userType === 'Read-Only' || userType === 'Appraiser'">New Board Member</button>
  </div>
</div>

<div class="row" *ngIf = 'displayState.gridDiv'>
  <div class="col-md-10 offset-1">
    <p-table [value]="boardList" [scrollable]="true" scrollHeight="540px"  >
      <ng-template pTemplate="header">
          <tr style="font-size:smaller">
              <th style="width: 10%" >&nbsp;</th>
              <th [pSortableColumn]="'memberName'" style="width: 15%">
                Board Member Name
                <p-sortIcon [field]="'memberName'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'email'" style="width: 20%" >
                  E-mail Address
                  <p-sortIcon [field]="'email'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'phone'" style="width: 15%">
                Phone
                <p-sortIcon [field]="'phone'"></p-sortIcon>
              </th>
              <th style="width: 10%" >&nbsp;</th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-member>
          <tr style="font-size: small;">
              <td style="width: 10%">
                  <button class='btn btn-sm btn-link' (click)="onSelect(member)" [disabled]="userType === 'Read-Only' || userType === 'Appraiser'">Select</button>
              </td>
              <td style="width: 15%">{{member.memberName}}</td>    
              <td style="width: 20%">{{member.email }}</td>
              <td style="width: 15%">{{member.phone}}</td>
              <td style="width: 10%">
                <button class='btn btn-sm btn-link' (click)="deleteBoardMember(member)" [disabled]="userType === 'Read-Only' || userType === 'Appraiser'">Delete</button>
            </td>

          </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<div class="row" *ngIf='displayState.editMemberDiv'>
    <div class="card bg-light col-md-6 offset-3">
        <div class="card-body">
           <div class="form-row" style="padding-bottom: 5px;">
                <!-- First Name -->
                <label for="memberName" class="col-md-4 col-form-label prd-label">Board Member Name</label>
                <input type="text" class="form-control col-md-8 prd-required" id="memberName" [(ngModel)]="myMember.memberName">
            </div>
            <div class="form-row" style="padding-bottom: 5px;">
                <label for="emailAddr" class="col-md-4 col-form-label prd-label">E-mail Address</label>
                <input type="text" class="form-control col-md-8" id="emailAddr" [(ngModel)]="myMember.email">
            </div>
            <div class="form-row">
                <label for="phoneNum" class="col-md-4 col-form-label prd-label">Phone</label>
                <input type="text" class="form-control col-md-8" id="phoneNum" [(ngModel)]="myMember.phone">
            </div>
            <br />
            <div class="form-row">
                <!-- Buttons -->
                <button class="btn btn-success offset-3" (click)="saveMember()" [disabled] = "displayState.saveDisabled" >Save</button>
                <button class="btn btn-warning offset-1" (click)="cancelEntry()">Cancel</button>
            </div>
        </div>
    </div>
</div>
